import React, { useState, useEffect, useRef } from "react";
import { styles } from "../style/AnimNum.styles";

interface AnimNumProps {
  value: number; // 目標數值
  color?: string; // 文字顏色
  size?: number; // 字體大小
  duration?: number; // 動畫時長 (ms)
  unit?: string;
}

export const AnimNum: React.FC<AnimNumProps> = ({ value, color = "#0F172A", size = 44, duration = 600, unit = "%" }) => {
  const [displayValue, setDisplayValue] = useState<number>(0);
  const requestRef = useRef<number>();
  const startTimeRef = useRef<number>();
  const startValueRef = useRef<number>(0);

  useEffect(() => {
    // 每次數值改變時，重置動畫起始點
    startValueRef.current = displayValue;
    startTimeRef.current = undefined;

    const animate = (timestamp: number) => {
      if (!startTimeRef.current) startTimeRef.current = timestamp;

      const progress = timestamp - startTimeRef.current;
      const percentage = Math.min(progress / duration, 1);

      // 使用 Ease-Out Cubic 公式讓動畫更細膩
      // formula: 1 - Math.pow(1 - x, 3)
      const easeOutCubic = 1 - Math.pow(1 - percentage, 3);

      const nextValue = Math.round(startValueRef.current + (value - startValueRef.current) * easeOutCubic);

      setDisplayValue(nextValue);

      if (percentage < 1) {
        requestRef.current = requestAnimationFrame(animate);
      }
    };

    requestRef.current = requestAnimationFrame(animate);

    // 清理函數：組件卸載時停止動畫，防止噴錯誤
    return () => {
      if (requestRef.current) cancelAnimationFrame(requestRef.current);
    };
  }, [value, duration]); // 當目標值改變時重新觸發

  return (
    <span style={styles.container(size, color)}>
      {unit === "NT$" && (
        <span style={styles.unit(size)} className="mx-2">
          {unit}
        </span>
      )}
      {Number(displayValue).toLocaleString()}
      {unit === "%" && (
        <span style={styles.unit(size)} className="mx-2">
          {unit}
        </span>
      )}
    </span>
  );
};

export default AnimNum;
